import React, { useState, useRef, useEffect } from 'react';
import styles from './ColorSelect.module.css';

const ColorSelect = ({ label = 'Color', options = [], onChange, value }) => {
  const [selectedColorId, setSelectedColorId] = useState(value ?? options[0]?.colorId);
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const handleSelect = (colorId) => {
    setSelectedColorId(colorId);
    setOpen(false);
    if (onChange) {
      const selected = options.find(opt => opt.colorId === colorId);
      onChange(selected);
    }
  };

  const handleClickOutside = (e) => {
    if (containerRef.current && !containerRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedColor = options.find(opt => opt.colorId === selectedColorId)?.colorValue;

  return (
    <div className={styles.wrapper} ref={containerRef}>
      <label className={styles.label}>{label}</label>
      <div
        className={styles.selected}
        onClick={() => setOpen(!open)}
      >
        <div
          className={styles.colorOption}
          style={{ backgroundColor: selectedColor }}
        />
      </div>
      {open && (
        <div className={styles.dropdown}>
          {options.map(({ colorId, colorValue }) => (
            <div
              key={colorId}
              className={styles.colorOption}
              style={{ backgroundColor: colorValue }}
              onClick={() => handleSelect(colorId)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ColorSelect;
